import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Utils, ImageResizing } from 'poly-js-utils';
import { connectToJSContext, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';
import SectionHeader from '../section_header/index.jsx';
import { PRODUCT_LIST } from '../constants';
import { selectProductsListFromProfileSelections } from './selectors';
import LazyImg from '../lazy_img/index.jsx';

const ProductInfo = ({ productIcon, productTitle, productBlurb }) => (
    <div>
        {productIcon && <LazyImg src={productIcon} alt={productTitle || ""} />}
        {productTitle && <h3 className="color-accent product-title">{productTitle}</h3>}
        {productBlurb &&
            <span className="product-blurb"
                dangerouslySetInnerHTML={{
                    __html: RA_73_STERILIZE_HTML_STRING(productBlurb)
                }}
            />
        }
    </div>
);

const Product = (props) => (
    <div className={`hs-product-${props.productId}`}>
        {props.productIconLink ?
            <a
                href={props.productIconLink}
                target="_blank" rel="noopener"
                data-product-name={props.productTitle}
                data-click-type="product"
            >
                <ProductInfo {...props} />
            </a>
            :
            <ProductInfo {...props} />
        }
    </div>
);

const ProductList = (props) => {
    const { limit,
        maxProductsPerRow,
        products,
        productsEmptyStateText,
        hasProductsPage,
        showHeader,
        showTagline
    } = props;
    const visibleProducts = products.slice(0, limit || products.length);
    const productGroups = _.groupBy(visibleProducts, (product, i) =>
        Math.floor(i / maxProductsPerRow)
    );
    const sectionHeaderProps = {
        title: props.headerText,
        sectionId: props.sectionId,
        buttonText: props.buttonText,
        switchRenderingOrder: props.switchRenderingOrder
    };

    if (showTagline) {
        sectionHeaderProps.tagline = props.headerTagline;
    }

    if (hasProductsPage) {
        sectionHeaderProps.buttonText = props.buttonText;
        sectionHeaderProps.buttonLabel = props.buttonLabel;
        sectionHeaderProps.buttonAttributes = {
            "data-product-name": "",
            "data-click-type": "product-view-all"
        };
        sectionHeaderProps.urlSlug = 'products';
    }

    const productClassName = products.length === 1 ? 'hs-product col-xs-12 col-sm-12 col-md-6 col-md-offset-3'
        : products.length === 2 ? 'hs-product col-xs-12 col-sm-12 col-md-4 col-md-offset-1'
            : 'hs-product col-xs-12 col-sm-12 col-md-4';
    return (
        <div className="c-product hs-section">
            {showHeader && props.headerText &&
                <SectionHeader
                    {...sectionHeaderProps}
                />
            }
            <div className="container">
                {!_.isEmpty(productGroups) ?
                    _.map(productGroups, (productGroup, i) =>
                        (<div className="row" key={i}>
                            {productGroup.map((productData, j) =>
                                (<div key={j} className={`${productClassName} hs-product-row-${i}`}>
                                    <Product {...productData} productId={i} />
                                </div>)
                            )}
                        </div>)
                    )
                    :
                    <div className="col-xs-12 empty-state">
                        <p dangerouslySetInnerHTML={{ __html: RA_73_STERILIZE_HTML_STRING(productsEmptyStateText) }} />
                    </div>
                }
            </div>
        </div>
    );
};

ProductList.propTypes = {
    productsEmptyStateText: PropTypes.string,
    maxProductsPerRow: PropTypes.number.isRequired,
    products: PropTypes.arrayOf(
        PropTypes.shape({
            productIcon: PropTypes.string,
            productTitle: PropTypes.string,
            productBlurb: PropTypes.string,
            productIconLink: PropTypes.string,
            productIconWide: PropTypes.string
        })
    ).isRequired,
    showHeader: PropTypes.bool,
    showTagline: PropTypes.bool
};

ProductList.defaultProps = {
    showHeader: PRODUCT_LIST.DEFAULT_PROPS.SHOW_HEADER
};

// export un-connected class for testing
export { ProductList };

const getIconProperty = (productData) => {
    if (
        productData.product_icon_wide &&
        productData.product_icon_wide_resize_ready &&
        productData.product_icon_type &&
        productData.product_icon_type.length > 0 &&
        productData.product_icon_type[0] === 'wide'
    ) {
        return 'product_icon_wide';
    }
    return 'product_icon';
};

const mapStateToProps = (state) => {
    const productsUrl = state.theme_data.nav.main_navigation_links.find(link => link.url === 'products');
    const productList = selectProductsListFromProfileSelections(state);
    return {
        productsEmptyStateText: state.theme_data.products_page.empty_state_text,
        maxProductsPerRow: 3,
        products: (productList).map(productData => {
            return {
                productIcon: ImageResizing.resize(productData, getIconProperty(productData), 400),
                productTitle: productData.product_title,
                productBlurb: productData.product_blurb,
                productIconLink: productData.product_icon_link
            };
        }),
        hasProductsPage: productsUrl && productsUrl.url,
        headerText: state.theme_data.products_page.header_title,
        headerTagline: state.theme_data.products_page.header_tagline,
        buttonText: state.theme_data.products_page.view_more_text,
        buttonLabel: state.theme_data.products_page.view_more_label || undefined,
        switchRenderingOrder: Utils.selectBoxIsTrue(state.theme_data.products_page.switch_rendering_order),
        sectionId: 'products',
        showTagline: Utils.selectBoxIsTrue(state.theme_data.home_page.is_tagline_included_in_home_page)
    };
};

export default connectToJSContext(mapStateToProps)(ProductList);



// WEBPACK FOOTER //
// ./components/product_list/index.jsx